const aiBackgroundGradient = {
  background: 'linear-gradient(to right, #183560, #00B2AD)',
  color: '#fff',
  borderRadius: '8px',
  display: 'inline-block',
  cursor: 'pointer',
  fontWeight: 'bold',
  fontSize: '16px',
  textAlign: 'center',
}

export { aiBackgroundGradient }
